import React, {useContext, useState} from "react";
import navbar from "../css/navbar.css";
import logo from "./Assets/logo.png";
import cart_icon from "./Assets/cart_icon.png";
import {Link} from "react-router-dom";
import {ShopContext} from "./Providers/ShopContext";

export default function Navbar() {
  const [menu, setMenu] = useState("shop");
  const {getTotalCartItem} = useContext(ShopContext);
  return (
    <div className="navbar" style={navbar}>
      <div className="nav-logo">
        <Link to={"/"} className="Link logo">
          {" "}
          <img src={logo} alt="brand logo" />
          <h1>SHOP WITH B</h1>
        </Link>
      </div>

      <ul className="nav-menu">
        <li
          onClick={() => {
            setMenu("shop");
          }}
        >
          <Link to="/" className="Link">
            Shop
          </Link>
          {menu === "shop" ? <hr /> : <></>}
        </li>
        <li
          onClick={() => {
            setMenu("men");
          }}
        >
          <Link to="/men" className="Link">
            Men
          </Link>
          {menu === "men" ? <hr /> : <></>}
        </li>
        <li
          onClick={() => {
            setMenu("women");
          }}
        >
          <Link to="/women" className="Link">
            Women
          </Link>
          {menu === "women" ? <hr /> : <></>}
        </li>
        <li
          onClick={() => {
            setMenu("kids");
          }}
        >
          <Link to="/kids" className="Link">
            Kids
          </Link>
          {menu === "kids" ? <hr /> : <></>}
        </li>
      </ul>

      <div className="nav-login-cart">
        <button>
          <Link to="login" className="Link">
            Login
          </Link>
        </button>
        <Link to="cart" className="Link cart-icon">
          <img src={cart_icon} alt="cart" />
        </Link>
        <div className="nav-cart-checker">{getTotalCartItem()}</div>
      </div>
    </div>
  );
}
